import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const IncreaseInCYRCEnrollments = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Increase in CYRC enrollments (%)" />
    </Box>
  );
};
